module.exports = __webpack_public_path__ + "img/montage.4a1286fa.png";